export const STORE_COMPETITOR_MANAGEMENT = 'competitors-management';
export const STORE_COMPETITOR_GROUPS = 'competitorGroups';
export const COM_GROUPS_SET_OPTIONS = 'setOptions';
export const COM_GROUPS_SET_STATE = 'setState';
export const COM_GROUPS_GET_COMPETITORS = 'getCompetitors';
export const COM_GROUPS_GET_MAP_COMPETITORS = 'getMapCompetitors';
export const COM_GROUPS_CHANGE_POSISTION = 'changePosition';
export const COM_GROUPS_DELETE = 'deleteGroup';
export const COM_GROUPS_CREATE = 'createGroup';
export const COM_GROUPS_UPDATE = 'updateGroup';

export const COM_GROUPS_ADD_HOTEL = 'addHotelToGroup';
export const COM_GROUPS_DELETE_HOTEL = 'deleteHotelFromGroup';

export const COM_GROUPS_DEFAULT_RADIUS = 2000;
export const COM_GROUPS_DEFAULT_PER_PAGE = 10;
export const COM_GROUPS_DEFAULT_LAYOUT = 'Map';
